import React, { useState, useEffect } from "react";
import MenuEditOptionsPanel from "../../common/MenuEditOptionsPanel";
import { navigate } from "../../../../helpers/utils";
import appPages from "../../../../appPages";

export default function IntegrationMenuOptions({
  controller,
  integration,
  returnUrl,
  timeslot,
  close = () => {},
}) {
  useEffect(() => {
    setSelectedIntegration(integration);
  }, [integration]);

  const [selectedIntegration, setSelectedIntegration] = useState(integration);

  // ------------------------------------- MENU -------------------------------------
  const getMenuOptions = () => {
    return [
      {
        text: "Associate Data with an Element",
        action: () => executeAction(appPages.integrationsMappingPage),
      },
      {
        text: "Ignore This Data",
        isDelete: true,
        action: () => executeAction(appPages.integrationsIgnorePage),
      },
      {
        text: "Delete this Entry",
        isDelete: true,
        action: () => executeAction(appPages.integrationsDeletePage),
      },
    ];
  };

  const executeAction = (pageUrl) => {
    setSelectedIntegration(null);

    navigate(controller, pageUrl, "changePage", {
      // Coming from integrations home or track-home
      integrations: _getPayloadData(integration),

      // 09.09.2021 for element mapping go to rules home or track details with newly selected element
      returnUrl,
      timeslot,
    });
  };

  const _getPayloadData = (data = {}) => {
    return data.source?.name?.indexOf("calendar_") == -1 && data.details
      ? data.details
      : [data];
  };

  return selectedIntegration ? (
    <MenuEditOptionsPanel
      isPanelActive={true}
      close={close}
      options={getMenuOptions(integration)}
      panelStyle={{
        bgStyle: {
          bottom: 50,
        },
      }}
    />
  ) : null;
}
